import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminStore } from "../stores/AdminStore";

export interface PedidoResumo {
  id: number;
  cliente_nome: string;
  cliente_email: string;
  status: string;
  total: number;
  frete: number;
}

export const AdminPedidos: React.FC = () => {
  const [pedidos, setPedidos] = useState<PedidoResumo[]>([]);
  const [modalDadosEnvio, setModalDadosEnvio] = useState<null | {
    cliente_cep: string;
    cliente_endereco: string;
    cliente_numero_casa: string;
    cliente_complemento: string;
    cliente_estado: string;
    forma_envio_id: number;
    forma_envio_nome: string;
  }>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalPedidoDetalhes, setModalPedidoDetalhes] = useState<null | Array<{
    produto_nome: string;
    preco: number;
    quantidade: number;
    desconto: number;
  }>>(null);
  const [modalPedidoOpen, setModalPedidoOpen] = useState(false);
  const [modalAtualizacoes, setModalAtualizacoes] = useState<null | Array<{
    pedido_status: string;
    date: string | null;
    concluido: boolean;
  }>>(null);
  const [modalAtualizacoesOpen, setModalAtualizacoesOpen] = useState(false);
  const [confirmSalvarOpen, setConfirmSalvarOpen] = useState(false);
  const [pedidoIdAtualizando, setPedidoIdAtualizando] = useState<number | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    adminStore.getPedidoList().then(setPedidos);
  }, []);

  const handleDatalhesEnvioView = async (pedido: number) => {
    const dadosEnvio = await adminStore.getPedidoDadosEnvio(pedido);
    if (dadosEnvio) {
      setModalDadosEnvio(dadosEnvio);
      setModalOpen(true);
    } else {
      setModalDadosEnvio(null);
      setModalOpen(false);
      alert("Não foi possível obter os dados de envio.");
    }
  };

  const handlePedidoDetalhesView = async (pedidoId: number) => {
    const itens = await adminStore.getPedidoDadosItens(pedidoId);
    setModalPedidoDetalhes(itens);
    setModalPedidoOpen(true);
  };

  const handleAtualizacoes = async (pedidoId: number) => {
    const atualizacoes = await adminStore.getPedidoAtualizacoes(pedidoId);
    setModalAtualizacoes(atualizacoes);
    setModalAtualizacoesOpen(true);
    setPedidoIdAtualizando(pedidoId); // Salva o id do pedido em edição
  };

  const handleSalvarAtualizacoes = () => {
    setConfirmSalvarOpen(true);
  };

  const handleConfirmSalvar = async () => {
    setConfirmSalvarOpen(false);
    if (pedidoIdAtualizando !== null && modalAtualizacoes) {
      // Monta o array de updates para a API
      const statusUpdates = modalAtualizacoes.map((a, idx) => ({
        id: idx + 1, // Ajuste aqui se o id real vier do backend, senão use o campo correto
        concluido: a.concluido,
      }));
      await adminStore.atualizarPedidoStatus(pedidoIdAtualizando, statusUpdates);
      // Opcional: feedback ao usuário ou recarregar lista
      setModalAtualizacoesOpen(false);
      setPedidoIdAtualizando(null);
    }
  };

  const handleCancelSalvar = () => {
    setConfirmSalvarOpen(false);
  };

  const handleToggleConcluido = (index: number) => {
    if (modalAtualizacoes) {
      const updatedAtualizacoes = [...modalAtualizacoes];
      updatedAtualizacoes[index].concluido = !updatedAtualizacoes[index].concluido;
      setModalAtualizacoes(updatedAtualizacoes);
    }
  };

  const handleView = (id: number) => {
    navigate(`/admin/pedido/${id}`);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          padding: 32,
          borderRadius: 10,
          width: "100%",
          maxWidth: 900,
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: 24 }}>
          Administração de Pedidos
        </h2>
        <table
          style={{ width: "100%", borderCollapse: "collapse", marginTop: 24 }}
        >
          <thead>
            <tr>
              <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>ID</th>
              <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>
                Cliente
              </th>
              <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>
                E-mail
              </th>
              <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>
                Detalhes envio
              </th>
              <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>
                Detalhes Pedido
              </th>
              <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>
                Status
              </th>
              <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>
                Total
              </th>
              <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>
                Frete
              </th>
              <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>
                Atualizações
              </th>
            </tr>
          </thead>
          <tbody>
            {pedidos.map((pedido) => (
              <tr key={pedido.id}>
                <td style={{ padding: 8 }}>{pedido.id}</td>
                <td style={{ padding: 8 }}>{pedido.cliente_nome}</td>
                <td style={{ padding: 8 }}>{pedido.cliente_email}</td>
                <td style={{ padding: 8 }}>
                  <button
                    style={{
                      background: "#198754",
                      color: "#fff",
                      border: "none",
                      borderRadius: 4,
                      padding: "6px 14px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleDatalhesEnvioView(pedido.id)}
                  >
                    Visualizar
                  </button>
                </td>
                <td style={{ padding: 8 }}>
                  <button
                    style={{
                      background: "#0d6efd",
                      color: "#fff",
                      border: "none",
                      borderRadius: 4,
                      padding: "6px 14px",
                      cursor: "pointer",
                    }}
                    onClick={() => handlePedidoDetalhesView(pedido.id)}
                  >
                    Visualizar
                  </button>
                </td>
                <td style={{ padding: 8 }}>{pedido.status}</td>
                <td style={{ padding: 8 }}>
                  {pedido.total.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </td>
                <td style={{ padding: 8 }}>
                  {pedido.frete.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </td>
                <td style={{ padding: 8 }}>
                  <button
                    style={{
                      background: "#ffc107",
                      color: "#000",
                      border: "none",
                      borderRadius: 4,
                      padding: "6px 14px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleAtualizacoes(pedido.id)}
                  >
                    Gerenciar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Modal de Dados de Envio */}
        {modalOpen && modalDadosEnvio && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.4)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2000,
            }}
            onClick={() => setModalOpen(false)}
          >
            <div
              style={{
                background: "#fff",
                padding: 32,
                borderRadius: 8,
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                minWidth: 320,
                textAlign: "left",
                position: "relative",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                style={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  background: "transparent",
                  border: "none",
                  fontSize: 20,
                  cursor: "pointer",
                }}
                onClick={() => setModalOpen(false)}
              >
                ×
              </button>
              <h3>Dados de Envio</h3>
              <div style={{ marginTop: 16 }}>
                <div>
                  <b>Endereço:</b> {modalDadosEnvio.cliente_endereco},{" "}
                  {modalDadosEnvio.cliente_numero_casa}
                </div>
                {modalDadosEnvio.cliente_complemento && (
                  <div>
                    <b>Complemento:</b> {modalDadosEnvio.cliente_complemento}
                  </div>
                )}
                <div>
                  <b>Estado:</b> {modalDadosEnvio.cliente_estado}
                </div>
                <div>
                  <b>CEP:</b> {modalDadosEnvio.cliente_cep}
                </div>
                <div>
                  <b>Forma de envio:</b> {modalDadosEnvio.forma_envio_nome}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal de Detalhes do Pedido */}
        {modalPedidoOpen && modalPedidoDetalhes && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.4)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2100,
            }}
            onClick={() => setModalPedidoOpen(false)}
          >
            <div
              style={{
                background: "#fff",
                padding: 32,
                borderRadius: 8,
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                minWidth: 400,
                textAlign: "left",
                position: "relative",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                style={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  background: "transparent",
                  border: "none",
                  fontSize: 20,
                  cursor: "pointer",
                }}
                onClick={() => setModalPedidoOpen(false)}
              >
                ×
              </button>
              <h3>Detalhes do Pedido</h3>
              <div style={{ marginTop: 16 }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>
                        Produto
                      </th>
                      <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>
                        Quantidade
                      </th>
                      <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>
                        Desconto
                      </th>
                      <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>
                        Preço unitário
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {modalPedidoDetalhes.map((item, idx) => (
                      <tr key={idx}>
                        <td style={{ padding: 8 }}>{item.produto_nome}</td>
                        <td style={{ padding: 8, textAlign: "center" }}>
                          {item.quantidade}
                        </td>
                        <td style={{ padding: 8, textAlign: "center" }}>
                          {item.desconto.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </td>
                        <td style={{ padding: 8, textAlign: "center" }}>
                          {item.preco.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* Modal de Atualizações */}
        {modalAtualizacoesOpen && modalAtualizacoes && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.4)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2200,
            }}
            onClick={() => setModalAtualizacoesOpen(false)}
          >
            <div
              style={{
                background: "#fff",
                padding: 32,
                borderRadius: 8,
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                minWidth: 500,
                textAlign: "left",
                position: "relative",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close button */}
              <button
                style={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  background: "transparent",
                  border: "none",
                  fontSize: 20,
                  cursor: "pointer",
                }}
                onClick={() => setModalAtualizacoesOpen(false)}
              >
                ×
              </button>
              {/* Title and Salvar button row */}
              <div style={{ display: "flex", alignItems: "center", marginBottom: 16 }}>
                <h3 style={{ flex: 1, margin: 0 }}>Atualizações do Pedido</h3>
                <button
                  style={{
                    background: "#198754",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    padding: "8px 16px",
                    marginLeft: 16,
                    cursor: "pointer",
                  }}
                  onClick={handleSalvarAtualizacoes}
                >
                  Salvar
                </button>
              </div>
              <div style={{ marginTop: 8 }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>
                        Status
                      </th>
                      <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>
                        Data
                      </th>
                      <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>
                        Concluído
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {modalAtualizacoes.map((atualizacao, idx) => (
                      <tr key={idx}>
                        <td style={{ padding: 8 }}>{atualizacao.pedido_status}</td>
                        <td style={{ padding: 8 }}>
                          {atualizacao.date
                            ? new Date(atualizacao.date).toLocaleString("pt-BR", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                            : ""}
                        </td>
                        <td style={{ padding: 8, textAlign: "center" }}>
                          <input
                            type="checkbox"
                            checked={atualizacao.concluido}
                            onChange={() => handleToggleConcluido(idx)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* Confirmar Salvar Atualizações */}
        {confirmSalvarOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.4)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 3000,
            }}
            onClick={handleCancelSalvar}
          >
            <div
              style={{
                background: "#fff",
                padding: 32,
                borderRadius: 8,
                minWidth: 320,
                textAlign: "center",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              }}
              onClick={e => e.stopPropagation()}
            >
              <h4>Deseja realmente salvar as atualizações deste pedido?</h4>
              <div style={{ marginTop: 24 }}>
                <button
                  style={{
                    background: "#198754",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    padding: "8px 18px",
                    marginRight: 12,
                    cursor: "pointer",
                  }}
                  onClick={handleConfirmSalvar}
                >
                  Sim
                </button>
                <button
                  style={{
                    background: "#dc3545",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    padding: "8px 18px",
                    cursor: "pointer",
                  }}
                  onClick={handleCancelSalvar}
                >
                  Não
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
